import React from 'react';

export default class LoggedOut extends React.Component {
  render() {
    return (
      <h1>Logged out</h1>
    );
  }
}
